// Keep FAQ initialization independent of optional sections on the page.
$(function () {
  document.querySelectorAll('.faq-videos-section').forEach((section) => {
    const items = Array.from(
      section.querySelectorAll('.faq-videos > .faq-item')
    );
    const button = section.querySelector('.load-more-button');
    const perLoad = 3;
    let visible = 0;

    const showNext = () => {
      const next = Math.min(visible + perLoad, items.length);

      items.slice(visible, next).forEach((item) => {
        item.style.display = 'block';
      });

      visible = next;
      if (button) button.style.display = visible < items.length ? '' : 'none';
    };

    if (button) {
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
      button.addEventListener('click', showNext);
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          showNext();
        }
      });
    }

    showNext();
  });
});
